import { render, staticRenderFns } from "./MatchSchedule.vue?vue&type=template&id=3b1df3ac&"
import script from "./MatchSchedule.vue?vue&type=script&lang=js&"
export * from "./MatchSchedule.vue?vue&type=script&lang=js&"
import style0 from "./MatchSchedule.vue?vue&type=style&index=0&id=3b1df3ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports